import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import CommitmentsGridPreview from "../commitments-grid-preview/CommitmentsGridPreview";
import useMain from "../../hooks/useMain";
import {getUsers} from "../../mongo-db/users";

const DialogPreviewCommitment = props => {
  const {close, templateId, formId, opening, setOpening} = props;

  const {fetchSavedForm} = useMain();

  const open = Boolean(templateId);

  const [commitments, setCommitments] = useState([]);
  const [findings, setFindings] = useState([]);
  const [responsible, setResponsible] = useState([]);
  const [noResults, setNoResults] = useState(false);

  useEffect(() => {
    if (!templateId) return;

    getUsers().then(usersData => {
      const mapped = usersData.map(user => ({
        value: user.email,
        label: user.name + (user.position ? ` - ${user.position}` : ""),
      }));
      setResponsible(mapped);
    });
  }, [templateId]);

  useEffect(() => {
    if (!formId || !templateId) {
      setCommitments([]);
      setFindings([]);
      setNoResults(false);
      return;
    }

    setOpening(true);
    fetchSavedForm(formId)
      .then(form => {
        const _commitments = form?.compromisos || [];
        const _findings = form?.hallazgos || [];
        setCommitments(_commitments);
        setFindings(_findings);
        setNoResults(_commitments.length < 1);
      })
      .finally(() => setOpening(false));
  }, [formId, templateId]);

  return (
    <Modal
      show={open}
      onHide={() => close()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Compromisos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CommitmentsGridPreview
          commitments={commitments}
          findings={findings}
          responsible={responsible}
        />
        {opening && (
          <div className="w-100 d-flex py-3 justify-content-center align-items-center">
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-3">Cargando...</span>
          </div>
        )}

        {noResults && (
          <div className="text-center fst-italic my-3">
            No se encontraron resultados.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => close()}
          disabled={opening}
        >
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogPreviewCommitment;
